import '@qicgroupdoha/loyalty-components/style.css'
import '@qic/ui-components/style.css'
import '@/shared/assets/styles/main.scss'
import { i18n } from '@/app/plugins/i18n'
import packageJson from '../../package.json'

import { SentryLib } from '@/app/plugins/sentry/sentry'

import VueScrollTo from 'vue-scrollto'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from '@/App.vue'
import router from '@/app/router'

const logVersion = () => {
  console.log(`version: ${packageJson.version}.${__COMMIT_HASH__}`)
}

logVersion()

const app = createApp(App)

SentryLib.init(app, router)

app.use(i18n)
const pinia = createPinia()
pinia.use(({ store }) => {
  store.$router = router
})

app.use(pinia)
app.use(router)

app.use(VueScrollTo)

app.mount('#app')
